module.exports = __webpack_public_path__ + "static/media/apple.99bbd91d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apple.svg
// module id = 1382
// module chunks = 0